export var UniversParameterBindingRead;
(function (UniversParameterBindingRead) {
    let default_mode;
    (function (default_mode) {
        default_mode["FIXED"] = "fixed";
        default_mode["MIN"] = "min";
        default_mode["MAX"] = "max";
        default_mode["MEDIAN"] = "median";
        default_mode["MEAN"] = "mean";
        default_mode["MIN_ALL"] = "min_all";
        default_mode["MAX_ALL"] = "max_all";
        default_mode["MEDIAN_ALL"] = "median_all";
        default_mode["MEAN_ALL"] = "mean_all";
    })(default_mode = UniversParameterBindingRead.default_mode || (UniversParameterBindingRead.default_mode = {}));
})(UniversParameterBindingRead || (UniversParameterBindingRead = {}));
